/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_N2Inputs */

const en_to_typescript_ref_n2 = /** @type {(inputs: To_Typescript_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straightforward.`)
};

const ko_to_typescript_ref_n2 = /** @type {(inputs: To_Typescript_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단순합니다.`)
};

const ja_to_typescript_ref_n2 = /** @type {(inputs: To_Typescript_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単純です。`)
};

/**
* | output |
* | --- |
* | "Straightforward." |
*
* @param {To_Typescript_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_n2 = /** @type {((inputs?: To_Typescript_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_n2(inputs)
	if (locale === "ko") return ko_to_typescript_ref_n2(inputs)
	return ja_to_typescript_ref_n2(inputs)
});